import React from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const AdminBreadcrumb = ({ path }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: 2,
      }}
    >
      {path.map((item, index) => (
        <React.Fragment key={index}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {item.link ? (
              <Button
                component={Link}
                to={item.link}
                sx={{
                  textTransform: 'none',
                  color: theme.palette.primary.main,
                  '&:hover': {
                    backgroundColor: 'transparent',
                    textDecoration: 'underline',
                  },
                }}
              >
                <Typography variant="body2">{item.label}</Typography>
              </Button>
            ) : (
              <Button
                disabled
                sx={{
                  textTransform: 'none',
                  color: theme.palette.text.disabled,
                }}
              >
                <Typography variant="body2">{item.label}</Typography>
              </Button>
            )}
          </Box>
          {index < path.length - 1 && (
            <ChevronRightIcon
              fontSize="small"
              sx={{ mx: 0.5, color: theme.palette.text.secondary }}
            />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default AdminBreadcrumb;
